import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Button,
    Table,
    Badge,
} from "react-bootstrap";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    PieChart,
    Pie,
    Cell,
    BarChart,
    Bar,
    ResponsiveContainer,
} from "recharts";
import { FaMapMarkerAlt, FaUserClock } from "react-icons/fa";
import { FaSearch, FaFilter } from "react-icons/fa";
import { FaDownload, FaUsers, FaHeart, FaRupeeSign } from "react-icons/fa";
import "../../report.css";

const lineData = [
    { name: "Jan", users: 400 },
    { name: "Feb", users: 800 },
    { name: "Mar", users: 1200 },
    { name: "Apr", users: 900 },
];

const pieData = [
    { name: "Bride", value: 60 },
    { name: "Groom", value: 40 },
];

const barData = [
    { name: "Basic", revenue: 2000 },
    { name: "Premium", revenue: 5000 },
    { name: "VIP", revenue: 8000 },
];


const topAreas = [
    { name: "Indiranagar", users: 320 },
    { name: "Koramangala", users: 250 },
    { name: "Jayanagar", users: 200 },
    { name: "HSR Layout", users: 180 },
    { name: "Whitefield", users: 130 },
];

const activities = [
    { text: "New profile registered", time: "2 mins ago" },
    { text: "Payment completed", time: "10 mins ago" },
    { text: "Match request sent", time: "30 mins ago" },
    { text: "Profile verified", time: "1 hour ago" },
];

const profiles = [
    {
        id: "#M123",
        name: "Kumar",
        gender: "Groom",
        status: "Active",
        plan: "Premium",
        date: "25 Mar",
    },
    {
        id: "#M126",
        name: "Priya S",
        gender: "Bride",
        status: "Verified",
        plan: "VIP",
        date: "24 Mar",
    },
     {
        id: "#M127",
        name: "anish",
        gender: "Groom",
        status: "Active",
        plan: "Premium",
        date: "25 Mar",
    },
     {
        id: "#M128",
        name: "Aron",
        gender: "Groom",
        status: "Active",
        plan: "Premium",
        date: "25 Mar",
    },
     {
        id: "#M129",
         name: "preshika",
        gender: "Bride",
        status: "Verified",
        plan: "Premium",
        date: "25 Mar",
    },
];

const COLORS = ["#ff6b6b", "#4dabf7"];

export default function Report() {
    return (
        <Container  className="report-page">


            <div className="report-header my-2">
                <h4>Matrimony Reports</h4>
                <Button className="export-btn">
                    <FaDownload /> Export Report
                </Button>
            </div>




            <Card className="filter-card premium-filter shadow-sm">
                <div className="filter-header">
                    <h6><FaFilter /> Filters</h6>
                </div>

                <Row className="g-3 align-items-end">

                    <Col md={2} sm={6}>
                        <label>From Date</label>
                        <Form.Control type="date" className="input-field" />
                    </Col>

                    <Col md={2} sm={6}>
                        <label>To Date</label>
                        <Form.Control type="date" className="input-field" />
                    </Col>

                    <Col md={2} sm={6}>
                        <label>Profile Type</label>
                        <Form.Select className="input-field">
                            <option>All Profiles</option>
                            <option>Bride</option>
                            <option>Groom</option>
                        </Form.Select>
                    </Col>

                    <Col md={2} sm={6}>
                        <label>Status</label>
                        <Form.Select className="input-field">
                            <option>Status</option>
                            <option>Active</option>
                            <option>Inactive</option>
                            <option>Verified</option>
                        </Form.Select>
                    </Col>

                    <Col md={3} sm={8}>
                        <label>Search</label>
                        <div className="search-box">
                            <FaSearch />
                            <Form.Control placeholder="Search ID / Name" />
                        </div>
                    </Col>

                    <Col md={1} sm={4}>
                        <Button className="apply-btn w-100">
                            Apply
                        </Button>
                    </Col>

                </Row>
            </Card>


            {/* <Row className="mt-3">
        <Col md={3}>
          <Card className="kpi-card gradient1">
            <FaUsers />
            <div>
              <h6>Total Profiles</h6>
              <h3>1,200</h3>
            </div>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="kpi-card gradient2">
            <FaUsers />
            <div>
              <h6>Active Users</h6>
              <h3>950</h3>
            </div>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="kpi-card gradient3">
            <FaHeart />
            <div>
              <h6>Matches</h6>
              <h3>300</h3>
            </div>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="kpi-card gradient4">
            <FaRupeeSign />
            <div>
              <h6>Revenue</h6>
              <h3>₹1.2L</h3>
            </div>
          </Card>
        </Col>
      </Row> */}

            <Row className="mt-4 g-3">


                <Col md={6}>
                    <Card className="premium-card">
                        <div className="card-header-flex">
                            <h6>Top Bangalore Areas</h6>
                        </div>

                        <div className="area-list">
                            {topAreas.map((area, i) => (
                                <div className="area-item" key={i}>
                                    <div className="area-left">
                                        <FaMapMarkerAlt className="icon" />
                                        <span>{area.name}</span>
                                    </div>
                                    <span className="badge-users">{area.users} Users</span>
                                </div>
                            ))}
                        </div>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card className="premium-card">
                        <div className="card-header-flex">
                            <h6>Recent Activity</h6>
                        </div>

                        <div className="activity-list">
                            {activities.map((item, i) => (
                                <div className="activity-item" key={i}>
                                    <FaUserClock className="icon" />
                                    <div>
                                        <p>{item.text}</p>
                                        <small>{item.time}</small>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Card>
                </Col>

            </Row>


            <Card className="premium-card table-card mt-4">
                <div className="card-header-flex">
                    <h6>Recent Profiles</h6>
                </div>

                <Table responsive hover className="custom-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Gender</th>
                            <th>Status</th>
                            <th>Plan</th>
                            <th>Date</th>
                        </tr>
                    </thead>

                    <tbody>
                        {profiles.map((p, i) => (
                            <tr key={i}>
                                <td>{p.id}</td>
                                <td>{p.name}</td>
                                <td>{p.gender}</td>
                                <td>
                                    <span className={`status ${p.status.toLowerCase()}`}>
                                        {p.status}
                                    </span>
                                </td>
                                <td>{p.plan}</td>
                                <td>{p.date}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>


            <Row className="mt-4 g-3">


                <Col md={6}>
                    <Card className="chart-card premium-card">
                        <div className="card-header-flex">
                            <div>
                                <h6>Profile Growth</h6>
                                <small>Monthly registrations</small>
                            </div>
                        </div>

                        <ResponsiveContainer width="100%" height={260}>
                            <LineChart data={lineData}>
                                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                                <YAxis tick={{ fontSize: 12 }} />
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="users"
                                    stroke="#ff9800"
                                    strokeWidth={3}
                                    dot={{ r: 4 }}
                                    activeDot={{ r: 6 }}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>


                <Col md={3}>
                    <Card className="chart-card premium-card text-center">
                        <div className="card-header-flex center">
                            <div>
                                <h6>Gender Ratio</h6>
                                <small>Distribution</small>
                            </div>
                        </div>

                        <ResponsiveContainer width="100%" height={260}>
                            <PieChart>
                                <Pie
                                    data={pieData}
                                    dataKey="value"
                                    outerRadius={85}
                                    innerRadius={50}
                                    paddingAngle={5}
                                >
                                    {pieData.map((_, i) => (
                                        <Cell key={i} fill={COLORS[i]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                            </PieChart>
                        </ResponsiveContainer>


                        <div className="custom-legend">
                            <span><div className="dot bride"></div> Bride</span>
                            <span><div className="dot groom"></div> Groom</span>
                        </div>
                    </Card>
                </Col>


                <Col md={3}>
                    <Card className="chart-card premium-card">
                        <div className="card-header-flex">
                            <div>
                                <h6>Revenue</h6>
                                <small>Plan wise earnings</small>
                            </div>
                        </div>

                        <ResponsiveContainer width="100%" height={260}>
                            <BarChart data={barData} barSize={30}>
                                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                                <YAxis tick={{ fontSize: 12 }} />
                                <Tooltip />
                                <Bar
                                    dataKey="revenue"
                                    radius={[10, 10, 0, 0]}
                                    fill="#ffc107"
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>

            </Row>

        </Container>
    );
}